// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-date-picker__wrapper {
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #999999;
  background: #FFFFFF;
}

.react-date-picker__inputGroup__input:invalid {
  background: unset;
}
`, "",{"version":3,"sources":["webpack://./src/components/input/DateInput.scss","webpack://./src/components/input/DateInput.css"],"names":[],"mappings":"AACE;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;ACAvB;;ADGI;EACE,iBAAiB;ACAvB","sourcesContent":[".react-date-picker {\n  &__wrapper {\n    padding: 16px;\n    border-radius: 8px;\n    border: 1px solid #999999;\n    background: #FFFFFF;\n  }\n  &__inputGroup {\n    &__input:invalid {\n      background: unset;\n    }\n  }\n}",".react-date-picker__wrapper {\n  padding: 16px;\n  border-radius: 8px;\n  border: 1px solid #999999;\n  background: #FFFFFF;\n}\n\n.react-date-picker__inputGroup__input:invalid {\n  background: unset;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
